import mori from 'mori';
import template from './notes.html';

export default function() {
  return {
    scope: {},
    templateUrl: template,
    controller: Controller,
    controllerAs: 'vm',
    bindToController: {
      data: '=',
    },
  };
}

Controller.$inject = ['$scope'];
function Controller($scope) {
  $scope.$watch(
    () => mori.hash(this.data),
    () => this.notes = mori.toJs(this.data)
  );
}



/** WEBPACK FOOTER **
 ** ../~/eslint-loader!./js/directives/notes/notes.js
 **/